import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  OptionsRoot,
  ParamsInterface,
  QueryParams,
  QueryParams2,
  RootOrden,
  StatusRoot,
} from '../interfaces/OrdenesInstalaciones.interface';
import { OrdenID } from '../interfaces/OrdenId.interface';
import { ResultHour, ResultOrders } from '../interfaces/OrdenesGrupoInterface';
import { Options } from '../interfaces/OptionsInterface';
import { GroupsRoot } from '../interfaces/Groups.interface';
import { Aprovisionar } from '../interfaces/Deposito.interface';
import { ContractDetailRoot } from '../interfaces/ContractDetail.interface';
import { Redes } from '../interfaces/AprovisionamientoInterface';
import { RootProvisioning } from '../interfaces/DetalleAprovisonamiento.interface';
import { QueryParamsService } from '../../finanzas/services/query-params.service';
import { AprovisionarBody } from '../ordenes-instalaciones/models/AprovisionarBody';

@Injectable({
  providedIn: 'root',
})
export class OrdenesInstalacionService {
  private http = inject(HttpClient);
  url = environment.API_URL;
  private queryParams = inject(QueryParamsService);

  constructor() {}

  getOrder(): Promise<RootOrden> {
    const obs$ = this.http.get<RootOrden>(
      `${this.url}/api/gsoft/installations/orders/`
    );
    return lastValueFrom(obs$);
  }
  getOrderParams(body: QueryParams2): Promise<any> {
    const res = this.queryParams.buildQueryParams(body);

    if (body?.report_orders) {
      const gt: any = `${this.url}/api/gsoft/installations/orders/?${res}`;
      return gt;
    }
    const obs$ = this.http.get<RootOrden>(
      `${this.url}/api/gsoft/installations/orders/`,
      { params: res }
    );
    return lastValueFrom(obs$);
  }
  getOrderStatics(body: QueryParams2): Promise<any> {
    const res = this.queryParams.buildQueryParams(body);
    const obs$ = this.http.get<any>(
      `${this.url}/api/gsoft/installations/orders/`,
      { params: res }
    );
    return lastValueFrom(obs$);
  }
  getStatusType(type = 11): Promise<StatusRoot> {
    const obs$ = this.http.get<StatusRoot>(
      `${this.url}/api/gsoft/services/status/?type=${type}`
    );
    return lastValueFrom(obs$);
  }

  getOptionsOrder(): Promise<OptionsRoot> {
    const obs$ = this.http.get<OptionsRoot>(
      `${this.url}/api/gsoft/installations/calendar/options/`
    );
    return lastValueFrom(obs$);
  }
  getOrderID(id: number): Promise<OrdenID> {
    const obs$ = this.http.get<OrdenID>(
      `${this.url}/api/gsoft/installations/orders/${id}/`
    );
    return lastValueFrom(obs$);
  }
  getOrdenesGroup(id: number, data: any): Promise<ResultOrders> {
    const http = this.http.get<ResultOrders>(
      `${this.url}/api/gsoft/installations/orders/?page=${data.page}&group=${id}&search=${data.search}&status=${data.status}&since=${data.since}&until=${data.until}&option=${data.option}`
    );
    return lastValueFrom(http);
  }
  getDepot(search: string): Promise<Aprovisionar[]> {
    const http = this.http.get<Aprovisionar[]>(
      `${this.url}/api/gsoft/depot/?delete_pagination=true&status=disponible&search=${search}`
    );
    return lastValueFrom(http);
  }
  getProducts(): Promise<any> {
    const http = this.http.get<any>(`${this.url}/api/services/products/`);
    return lastValueFrom(http);
  }
  getRedes(): Promise<Redes[]> {
    const http = this.http.get<Redes[]>(`${this.url}/api/gsoft/network/ipv4/`);
    return lastValueFrom(http);
  }
  getRouters(): Promise<any> {
    const http = this.http.get<any>(`${this.url}/api/gsoft/network/routers/`);
    return lastValueFrom(http);
  }
  getInterfaces(params: ParamsInterface): Promise<any> {
    const resparams = this.queryParams.buildQueryParams(params);
    const http = this.http.get<any>(
      `${this.url}/api/gsoft/network/router/${params.id}/interface/`,
      { params: resparams }
    );
    return lastValueFrom(http);
  }

  getRedesByNodo(nodo: number): Promise<Redes[]> {
    const http = this.http.get<Redes[]>(
      `${this.url}/api/gsoft/network/ipv4/?node=${nodo}`
    );
    return lastValueFrom(http);
  }

  getCalcularIp(redes: any): Promise<any> {
    const http = this.http.get<any>(
      `${this.url}/api/gsoft/network/ipv4/?ipv4=${redes.id}`
    );
    return lastValueFrom(http);
  }
  getStatistics(id: number, data: any): Promise<ResultHour> {
    const http = this.http.get<ResultHour>(
      `${this.url}/api/gsoft/installations/groups/statistics/?group=${id}&search=${data.search}&status=${data.status}&since=${data.since}&until=${data.until}&option=${data.option}`
    );
    return lastValueFrom(http);
  }

  reprogrammingOrder(id: number, body: any): Promise<{ status: string }> {
    const obs$ = this.http.patch<{ status: string }>(
      `${this.url}/api/gsoft/installations/orders/${id}/?reprogramming=true`,
      body
    );
    return lastValueFrom(obs$);
  }
  getContractDetail(contract: number): Promise<ContractDetailRoot> {
    const http = this.http.get<ContractDetailRoot>(
      `${this.url}/api/gsoft/contracts/details/?contract=${contract}&service_type=1&status=1`
    );
    return lastValueFrom(http);
  }
  getGroups(): Promise<GroupsRoot> {
    const http = this.http.get<GroupsRoot>(
      `${this.url}/api/gsoft/installations/groups/`
    );
    return lastValueFrom(http);
  }
  getGroupsAll(): Promise<GroupsRoot> {
    const http = this.http.get<GroupsRoot>(
      `${this.url}/api/gsoft/installations/groups/?pagination_remove=${true}`
    );
    return lastValueFrom(http);
  }

  getHoursGroup(data: any) {
    const http = this.http.get<any>(
      `${this.url}/api/gsoft/installations/groups/${data.idGroup}/?available_time=true&date=${data.date}`
    );
    return lastValueFrom(http);
  }

  transferOrder(id: number, body: any): Promise<{ status: string }> {
    const obs$ = this.http.patch<{ status: string }>(
      `${this.url}/api/gsoft/installations/orders/${id}/?transfer_order=true`,
      body
    );
    return lastValueFrom(obs$);
  }

  getOptions(): Promise<Options> {
    const http = this.http.get<Options>(
      `${this.url}/api/gsoft/installations/calendar/options/`
    );
    return lastValueFrom(http);
  }

  saveSft(id: number, body: any): Promise<{ status: string }> {
    const obs$ = this.http.patch<{ status: string }>(
      `${this.url}/api/gsoft/installations/orders/${id}/`,
      body
    );
    return lastValueFrom(obs$);
  }

  statusCancelOrden(body: any, id: number) {
    const obs$ = this.http.patch(
      `${this.url}/api/gsoft/installations/orders/${id}/cancel/`,
      body
    );
    return lastValueFrom(obs$);
  }
  statusOrden(body: any, id: number) {
    const obs$ = this.http.patch(
      `${this.url}/api/gsoft/installations/orders/${id}/?change_status=true`,
      body
    );
    return lastValueFrom(obs$);
  }
  replaceOrder(body: any, id: number, id_replace: number): Promise<any> {
    const obs$ = this.http.patch<any>(
      `${this.url}/api/gsoft/installations/orders/${id}/?replace_order=${id_replace}`,
      body
    );
    return lastValueFrom(obs$);
  }
  getGroupsUbication(
    id_ubication: number,
    id_zone: any,
    payment: boolean
  ): Promise<any> {
    const http = this.http.get<any>(
      `${this.url}/api/gsoft/installations/groups/?&zone=${id_zone}&vip=${payment}`
    );
    return lastValueFrom(http);
  }
  getGroupsUbicationSelect(
    id_ubication: number,
    id_zone: any,
    payment: boolean
  ): Promise<any> {
    const http = this.http.get<any>(
      `${this.url}/api/gsoft/installations/groups/?pagination_remove=true&status_id=1&zone=${id_zone}&vip=${payment}`
    );
    return lastValueFrom(http);
  }
  setServiceCDetail(body: AprovisionarBody): Promise<any> {
    const obs$ = this.http.post<any>(
      `${this.url}/api/gsoft/contracts/service_detail/`,
      body
    );
    return lastValueFrom(obs$);
  }
  deleteServiceCDetail(id: number): Promise<any> {
    const obs$ = this.http.delete<any>(
      `${this.url}/api/gsoft/contracts/service_detail/${id}/`
    );
    return lastValueFrom(obs$);
  }

  chargeImages(body: any): Promise<any> {
    const obs$ = this.http.post<any>(
      `${this.url}/api/gsoft/installations/image/`,
      body
    );
    return lastValueFrom(obs$);
  }

  getProvisioning(order: string): Promise<RootProvisioning> {
    const http = this.http.get<RootProvisioning>(
      `${this.url}/api/gsoft/geeze/network/contract/provisioning/?contract__installation_order_id=${order}`
    );
    return lastValueFrom(http);
  }

  addNewProduct(body: any): Promise<any> {
    const obs$ = this.http.post<any>(`${this.url}/api/gsoft/depot/`, body);
    return lastValueFrom(obs$);
  }
}
